
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[id]/[pageId]",
      function () {
        return require("private-next-pages/categories/[id]/[pageId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/[id]/[pageId]"])
      });
    }
  